import intersection from "lodash/intersection";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import { changesets } from "../../policies/actions";
import { OptionShape } from "../../policies/proptypes";
import Loader from "../../shared/components/Loader";
import { auditLogEntities,auditLogs } from "../actions";
import LogsFilter from "../components/LogsFilter";
import LogsGlobalFilter from "../components/LogsGlobalFilter";
import LogsTable from "../components/LogsTable";
import logsTableSelectors from "../selectors";

const dates = [
  { label: "1 month ago", key: "1" },
  { label: "3 months ago", key: "3" },
  { label: "6 months ago", key: "6" }
];

class Logs extends Component {
  title = "RBAC - Logs";

  state = { authorFilter: "", dateFilter: "", globalFilter: "" };

  componentDidMount() {
    const { fetchChangesets, fetchLogs, fetchLogEntities } = this.props;
    fetchChangesets();
    fetchLogs();
    fetchLogEntities();
  }

  setFilter = (type, filter) => {
    this.setState({ [`${type}Filter`]: filter });
  };

  filterByAuthor = uri => {
    const { logs } = this.props;

    if (!uri) {
      return logs;
    }
    return logs.filter(log => log.author.$uri === uri);
  };

  filterByDate = month => {
    const { logs } = this.props;
    const date = new Date();

    if (!month) {
      return logs;
    }
    // Set date range to month filter, and zero hours and milliseconds
    date.setMonth(date.getMonth() - month);
    date.setHours(0, 0, 0);
    date.setMilliseconds(0);
    return logs.filter(log => log.date.utc > date.getTime());
  };

  filterByGlobal = filter => {
    const { logs } = this.props;
    const globalFilter = filter.toLowerCase();

    if (!filter) {
      return logs;
    }
    return logs.filter(log => {
      const { author, event, activity, description } = log;
      return (
        (author && author.label.toLowerCase().includes(globalFilter)) ||
        (event && event.toLowerCase().includes(globalFilter)) ||
        (activity && activity.toLowerCase().includes(globalFilter)) ||
        (description && description.toLowerCase().includes(globalFilter))
      );
    });
  };

  getFilteredLogs = () => {
    const { authorFilter, dateFilter, globalFilter } = this.state;

    const filteredByAuthor = this.filterByAuthor(authorFilter);
    const filteredByDate = this.filterByDate(dateFilter);
    const filteredByGlobal = this.filterByGlobal(globalFilter);

    return intersection(filteredByAuthor, filteredByDate, filteredByGlobal);
  };

  render() {
    const { authorFilter, dateFilter, globalFilter } = this.state;
    const { loading, authors } = this.props;
    const logs = this.getFilteredLogs();

    return (
      <div className="l-logs">
        <DocumentTitle title={this.title} />
        <div className="l-logs__action-bar">
          <div style={{ gridArea: "date" }}>
            <LogsFilter
              type="date"
              filter={dateFilter}
              setFilter={this.setFilter}
              options={dates}
              position="left"
              showFilter={false}
            >
              Date range
            </LogsFilter>
          </div>
          <div style={{ gridArea: "dropdowns" }}>
            <LogsFilter
              type="author"
              filter={authorFilter}
              setFilter={this.setFilter}
              options={authors}
            >
              Authors
            </LogsFilter>
          </div>
          <div style={{ gridArea: "filter" }}>
            <LogsGlobalFilter
              filter={globalFilter}
              setFilter={this.setFilter}
            />
          </div>
        </div>
        {loading ? (
          <Loader text="Loading logs..." />
        ) : (
          <LogsTable logs={logs} />
        )}
      </div>
    );
  }
}

Logs.propTypes = {
  authors: PropTypes.arrayOf(OptionShape).isRequired,
  fetchChangesets: PropTypes.func.isRequired,
  fetchLogs: PropTypes.func.isRequired,
  fetchLogEntities: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  logs: PropTypes.arrayOf(PropTypes.object).isRequired
};

const mapStateToProps = state => ({
  loading: state.auditLogs.loading,
  logs: logsTableSelectors.get(state),
  authors: logsTableSelectors.getUniqueAuthors(state)
});

const mapDispatchToProps = {
  fetchChangesets: auditLogs.request,
  fetchLogs: changesets.request,
  fetchLogEntities: auditLogEntities.request
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logs);

export { Logs as LogsComponent };
